import { Input } from "@/components/ui/input";

export const parseMoney = (s: string) => {
  const clean = s.replace(/,/g, "").trim();
  return clean === "" ? NaN : Number(clean);
};

export const formatMoneyInput = (s: string) => {
  const n = parseMoney(s);
  return Number.isNaN(n) ? s : n.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const moneyInputValue = (n: number | null | undefined) => (n == null ? "" : formatMoneyInput(String(n)));

interface Props {
  id: string;
  value: string;
  onChange: (v: string) => void;
  testId: string;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

export function MoneyInput({ id, value, onChange, testId, className = "", disabled, autoFocus }: Props) {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">$</span>
      <Input
        id={id} type="text" inputMode="decimal" autoComplete="off" value={value} disabled={disabled} autoFocus={autoFocus}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value.replace(/[^\d.,]/g, ""))}
        onFocus={() => onChange(value.replace(/,/g, ""))}
        onBlur={() => onChange(formatMoneyInput(value))}
        className={`tabular pl-7 ${className}`} data-testid={testId}
      />
    </div>
  );
}
